import type { IconType } from 'react-icons';
import {
  MdApartment,
  MdCalendarMonth,
  MdCardGiftcard,
  MdCheckCircle,
  MdConfirmationNumber,
  MdCreditCard,
  MdDirectionsCar,
  MdEvStation,
  MdFlight,
  MdHotel,
  MdLocationOn,
  MdMail,
  MdPerson,
  MdPhone,
  MdQrCode2,
  MdSchedule,
  MdShield,
  MdSmartphone,
  MdStar,
  MdWork,
} from 'react-icons/md';

import type { SiteIcon } from './SitePage.types';

/**
 * The ONE mapping from the api's icon names to `Md*` glyphs, shared by QUICK_ACTIONS and
 * FEATURE_GRID. `Record<SiteIcon, …>` makes a missing entry a compile error when the icon set grows.
 */
export const SITE_ICONS: Record<SiteIcon, IconType> = {
  CAR: MdDirectionsCar,
  CALENDAR: MdCalendarMonth,
  CREDIT_CARD: MdCreditCard,
  QR_CODE: MdQrCode2,
  TICKET: MdConfirmationNumber,
  MAP_PIN: MdLocationOn,
  BUILDING: MdApartment,
  PHONE: MdPhone,
  MAIL: MdMail,
  STAR: MdStar,
  SHIELD: MdShield,
  CLOCK: MdSchedule,
  EV_CHARGER: MdEvStation,
  PLANE: MdFlight,
  HOTEL: MdHotel,
  BRIEFCASE: MdWork,
  USER: MdPerson,
  MOBILE: MdSmartphone,
  CHECK: MdCheckCircle,
  GIFT: MdCardGiftcard,
};

/** The icon for an api icon name, or undefined when absent/unknown (own-property lookup only). */
export function getSiteIcon(name: string | undefined): IconType | undefined {
  if (!name || !Object.prototype.hasOwnProperty.call(SITE_ICONS, name)) return undefined;
  return SITE_ICONS[name as SiteIcon];
}
